const Client = require("../modules/ModHttpsClient")

module.exports = {
    create(data) {
        return Client.post(data, {
            path: "/purchase/create"
        })
    },
    payrexx(data) {
        console.log("ModPurchase.payrexx")
        console.log(data)
        return Client.post(data, {
            path: "/purchase/payrexx"
        })
    },
    read(id, lang) {
        return Client.get([
            {
                key: "id",
                value: id
            },
            {
                key: "lang",
                value: lang
            }
        ], {
            path: "/purchase/read"
        })
    },
    productIdsOnly(id) {
        return Client.get([
            {
                key: "id",
                value: id
            },
            {
                key: "mode",
                value: "2"
            }
        ], {
            path: "/purchase/read"
        })
    },
    getLogo(id) {
        return Client.get([
            {
                key: "id",
                value: id
            }
        ], {
            path: "/purchase/productlogo"
        })
    },
    loadRef(ref) {
        return Client.get([
            {
                key: "ref",
                value: ref
            }
        ], {
            path: "/purchase/load/ref"
        })
    }
}